import { PriceStrategy } from '@snap-types/models/enums';

import { alphaUIConfig } from './strategies/alpha';
import { capPriceSegmentationUIConfig } from './strategies/cap-price-segmentation';
import { fixedCustomerUIConfig } from './strategies/fixed-customer';
import { fixedDefaultUIConfig } from './strategies/fixed-default';
import { fixedDiscountUIConfig } from './strategies/fixed-discount';
import { fixedMarketUIConfig } from './strategies/fixed-market';
import { newPartUIConfig } from './strategies/new-part';
import { newPartUserCostUIConfig } from './strategies/new-part-user-cost';
import { newPartUserPriceUIConfig } from './strategies/new-part-user-price';
import { priceSegmentationUIConfig } from './strategies/price-segmentation';
import { priceSegmentationWithTargetGrossMarginUIConfig } from './strategies/price-segmentation-with-target-gross-margin';
import { rafFixedMarketUIConfig } from './strategies/raf-fixed-market';
import { rafTargetGrossMarginUIConfig } from './strategies/raf-target-gross-margin';
import { targetContributionMarginUIConfig } from './strategies/target-contribution-margin';
import { targetGrossMarginUIConfig } from './strategies/target-gross-margin';
import { userImportUIConfig } from './strategies/user-import';
import { userPriceUIConfig } from './strategies/user-price';
import type { PriceStrategyUIConfig } from './types';

export * from './types';

export const priceStrategyUIConfig: PriceStrategyUIConfig = {
  [PriceStrategy.PriceSegmentation]: priceSegmentationUIConfig,
  [PriceStrategy.FixedMarket]: fixedMarketUIConfig,
  [PriceStrategy.FixedDiscount]: fixedDiscountUIConfig,
  [PriceStrategy.FixedCustomer]: fixedCustomerUIConfig,
  [PriceStrategy.FixedDefault]: fixedDefaultUIConfig,
  [PriceStrategy.TargetContributionMargin]: targetContributionMarginUIConfig,
  [PriceStrategy.TargetGrossMargin]: targetGrossMarginUIConfig,
  [PriceStrategy.UserPrice]: userPriceUIConfig,

  // @NOTE(mrs): Service Charge uses a completely separate display component,
  // so we are just copying UserPrice to satisfy completeness on the Enum
  [PriceStrategy.ServiceCharge]: userPriceUIConfig,
  [PriceStrategy.NewPart]: newPartUIConfig,
  [PriceStrategy.NewPartUserCost]: newPartUserCostUIConfig,
  [PriceStrategy.NewPartUserPrice]: newPartUserPriceUIConfig,
  [PriceStrategy.CAPPriceSegmentation]: capPriceSegmentationUIConfig,
  [PriceStrategy.RAFFixedMarket]: rafFixedMarketUIConfig,
  [PriceStrategy.RAFTargetGrossMargin]: rafTargetGrossMarginUIConfig,
  [PriceStrategy.UserImport]: userImportUIConfig,
  [PriceStrategy.PriceSegmentationWithTargetGrossMargin]:
    priceSegmentationWithTargetGrossMarginUIConfig,
  [PriceStrategy.Alpha]: alphaUIConfig,
} as const;

export const PRICE_STRATEGIES_WITHOUT_ADDABLE_QUOTE_PRICES: PriceStrategy[] = [
  PriceStrategy.PriceSegmentation,
  PriceStrategy.Alpha,
];
